import { AppProvider, rootProvider } from '@/providers';

function App() {
  return <AppProvider components={rootProvider} />;
}

export default App;
